import * as React from "react";
import { connect } from "react-redux";
import { Modal, Button } from "semantic-ui-react";

import { PartiallyMatchedEmployeeDetailModel } from "../model";

import { PartiallyMatchedFormDetails } from "./PartiallyMatchedFormDetails";

interface OwnProps {
    open: boolean;
    title: string;
    onClose: () => void;
    formDetails: PartiallyMatchedEmployeeDetailModel;
    showAdditionalMatchDetails?: boolean;
    isSubmitting: boolean;
}

interface DispatchProps {
    matchEmployeeToNewEmployeeRecord: (referralCustomerId: string, referralId: string) => void;
}

export const CreateNewEmployeeConfirmationModalUnconnected: React.FunctionComponent<OwnProps & DispatchProps> = props => {

    const onConfirm = () => {
        props.matchEmployeeToNewEmployeeRecord(props.formDetails.customerId, props.formDetails.id);
        props.onClose();
    };

    return (
        <Modal open={props.open} size="small">
            <Modal.Header>
                Create a new record from {props.title} Form Details
            </Modal.Header>
            <Modal.Content>
                <span>
                    Are you sure you want to create a new employee record based on the following information?
                </span>
                <PartiallyMatchedFormDetails
                    formDetails={props.formDetails}
                    showAdditionalMatchDetails={props.showAdditionalMatchDetails}
                />
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={() => props.onClose()}>Cancel</Button>
                <Button
                    primary
                    onClick={onConfirm}
                    className="create-new-employee-record-button"
                    loading={props.isSubmitting}
                    disabled={props.isSubmitting}
                >
                    Create new record
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export const CreateNewEmployeeConfirmationModal = connect()(CreateNewEmployeeConfirmationModalUnconnected);
